export const Unlocked = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="15" width="18" height="14" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M21 15H11V8C11 5.23858 13.2386 3 16 3V3C18.7614 3 21 5.23858 21 8V8" stroke="currentColor" stroke-width="2"/>
</svg>`;
